angular.module('access.Session')
    .constant('LOGIN_INFO_API_BASE_URL', '/api/platform-login-info/v1')
    .factory('CloudPlatformLoginInfo', [
        'CloudPlatformAccountServerRequest',
        'LOGIN_INFO_API_BASE_URL',
        'CloudPlatformUserInfo',
        function (CloudPlatformAccountServerRequest, LOGIN_INFO_API_BASE_URL, CloudPlatformUserInfo) {
            var EXPIRATIONS_API_ENDPOINT = LOGIN_INFO_API_BASE_URL + '/expirations';

            return {
                getExpirations: function () {
                    return CloudPlatformUserInfo.getMe()
                        .then(function (account) {
                            return CloudPlatformAccountServerRequest.get(EXPIRATIONS_API_ENDPOINT, { user_id: account.id }, {
                                failOnEmptyResponse: true,
                                failOnRedirect: true
                            });
                        })
                        .then(function (expirations) {
                            /**
                             * We'll have to verify the data, because we could expect anything from BE
                             * @see https://pmc.acronis.work/browse/ASRV-12166
                             * 
                             * We'll verify the response based on the following RAML -
                             * https://git.acronis.work/projects/ASK/repos/platform-login-info/browse/raml/api.raml
                             */
                            if (
                                // Check 
                                !angular.isString(expirations.user_id) ||
                                expirations.user_id === '' ||
                                !angular.isNumber(expirations.days_until_expiration)
                            ) {
                                throw new Error('Expiration data is invalid!');
                            }

                            return expirations;
                        })
                }
            };
        }
    ]);
